import { Component, Output, Input, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';

import { DialogDownloadComponent } from '../../dialogs/dialog-download/dialog-download.component';

/**
 * Select a chart based on charts enabled and download images and data
 */
@Component({
  selector: 'app-charts-selection-bar',
  templateUrl: './charts-selection-bar.component.html',
  styleUrls: ['./charts-selection-bar.component.scss']
})
export class ChartsSelectionBarComponent {
  /** dialog inject */
  dialog: MatDialog;
  /** Emitter when a chart was selected */
  @Output() selectChart = new EventEmitter<number>();
  /** Emitter when share options are displayed */
  @Output() toggleShareOptions = new EventEmitter<any>();
  /** Chart that was selected */
  @Input() selectedChart: string;
  /** List of charts that are enabled */
  @Input() charts: object;
  /** Data to download */
  @Input() dataToDraw: object[];
  /** Source of the data to download */
  @Input() source?: string;
  /** Generated title to display in data file */
  @Input() generatedTitle: string;
  /** Filters to show in image and data */
  @Input() generatedFiltersText: string;
  /** Image data to download */
  imageJPG: string;
  /** Page url also can be shared */
  sharePage = false;
  /** Init component, Inject MatDialog */
  constructor(dialog: MatDialog) {
    this.dialog = dialog;
  }

  /** Open dialog to download data and images */
  openDownloadsDialog() {
    const dialogRef = this.dialog.open(DialogDownloadComponent, {
      panelClass: 'dark-themed-dialog',
      height: '550px',
      width: '500px',
      data: {
        dataToDraw: this.dataToDraw,
        source: this.source,
        title: 'Descarga-Datos de ' + this.source,
        cleanTitle: this.generatedTitle,
        filters: this.generatedFiltersText
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.imageJPG = result.image;
    });
  }

  /** Emit selected chart */
  chartSelected(id) {
    this.selectChart.emit(id);
  }

  /** Display share options */
  showShareOptions() {
    this.sharePage = !this.sharePage;
    this.toggleShareOptions.emit(this.sharePage);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/charts-selection-bar/charts-selection-bar.component.ts